import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import Swal from "sweetalert2";

const AddBill = () => {
  const [partyName, setPartyName] = useState('');
  const [images, setImages] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle input changes
  const handlePartyNameChange = (event) => {
    setPartyName(event.target.value);
  };

  const handleImageChange = (event) => {
    const files = event.target.files;
    setImageFiles(files);

    // Prepare image URLs to preview
    const imageUrls = Array.from(files).map((file) => URL.createObjectURL(file));
    setImages(imageUrls);
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    setLoading(true);

    // Prepare form data to send to the API
    const formData = new FormData();
    formData.append('party_name', partyName);
    
    // Append each image file to the FormData
    Array.from(imageFiles).forEach((file) => {
      formData.append('images', file);
    });

    try {
      const response = await fetch(`${BASE_URL}billmodule`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();

      if (data.status === 1) {
       Swal.fire({
         icon: "success",
         title: "Bill Module added successfully",
       });
        navigate('/BillModuleList');  // Navigate to the bill module list page after successful addition
      } else {
        alert('Failed to add Bill Module');
      }
    } catch (error) {
      console.error('Error adding bill module:', error);
      alert('Error adding bill module');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Add Bill Module</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row" id="basic-table">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add New Bill Module</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="partyName" className="form-label">Party Name</label>
                    <input
                      type="text"
                      id="partyName"
                      className="form-control"
                      placeholder="Enter party name"
                      value={partyName}
                      onChange={handlePartyNameChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="images" className="form-label">Images</label>
                    <input
                      type="file"
                      id="images"
                      className="form-control"
                      accept="image/*"
                      multiple
                      onChange={handleImageChange}
                    />
                  </div>

                  {images.length > 0 && (
                    <div className="mb-3">
                      <h5>Image Previews:</h5>
                      <div className="d-flex flex-wrap">
                        {images.map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt={`Preview ${index}`}
                            style={{ width: '100px', height: 'auto', marginRight: '10px', marginBottom: '10px' }}
                          />
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="mb-3 text-end">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Adding...' : 'Add Bill Module'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddBill;
